import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65035c43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "heatmaps-quantification-legend" }
const _hoisted_2 = { class: "legend-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mid-line" }, null, -1))
const _hoisted_4 = { class: "category-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mid-line" }, null, -1))
const _hoisted_6 = { id: "legend-container-1" }
const _hoisted_7 = { class: "legend-icon-wrapper" }
const _hoisted_8 = { class: "legend-header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mid-line" }, null, -1))
const _hoisted_10 = { class: "category-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mid-line" }, null, -1))
const _hoisted_12 = { id: "legend-container-2" }
const _hoisted_13 = { class: "legend-icon-wrapper" }
const _hoisted_14 = { class: "legend-item-text" }
const _hoisted_15 = { class: "lengend-text" }
const _hoisted_16 = {
  key: 0,
  class: "info"
}
const _hoisted_17 = { class: "info-tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ib_icons = _resolveComponent("ib-icons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("heatmapLegendQuantification.cellsHeader")), 1),
      _hoisted_5
    ]),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellsTRenderInLegend, (value, key, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "legend-item",
          key: `legend-item-${index}`
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              style: _normalizeStyle(value),
              class: _normalizeClass(["legend-icon", _ctx.computeIconStyle(key)])
            }, null, 6)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.computeTextStyle(key))
          }, _toDisplayString(_ctx.t(value.text)), 3)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("heatmapLegendQuantification.areaContoursHeader")), 1),
      _hoisted_11
    ]),
    _createElementVNode("ul", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quantificationLegendObjects.curves, (value, key, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "legend-item",
          key: `legend-item-${index}`
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "legend-icon",
              style: _normalizeStyle(value)
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t(value.text)), 1),
            (value.info)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createVNode(_component_ib_icons, {
                    class: "info-circle",
                    icon: 'information',
                    color: 'primary',
                    size: 14
                  }),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t(value.info)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}